import { render, staticRenderFns } from "./gameunclaimed.vue?vue&type=template&id=3001cf54&"
import script from "./gameunclaimed.vue?vue&type=script&lang=js&"
export * from "./gameunclaimed.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./gameunclaimed.vue?vue&type=style&index=1&id=3001cf54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports